module.exports = __webpack_public_path__ + "img/underwriting_reports_beta.fc52ca72.png";